module.exports = __webpack_public_path__ + "static/LamarLogoQcify-7f9b3ac8526393d0b80172ba299a973c.png";